import React from "react";
import { object, bool, number, array, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import Tags from "../../atoms/Tags";
import { getExcerpt, getHeadline } from "../../utils/utils";
import StoryMetaData from "../StoryMetaData";
import Play from "../../../components/atoms/icons/Play";

import { staticTexts } from "../../utils/Translate";

import "./customStoryCard2.m.css";

const CustomStoryCard2 = ({
  story,
  isMetaDataShown = true,
  isTagShown = false,
  headlineLevel = 2,
  headlineType = 10,
  excerptLevel = 4,
  subHeadlineType = 6,
  isImageCaptionRequired = true,
  widths = [250, 480, 764],
  imageType = "image3x2",
  aspectRatio = [3, 2],
  showHeroImage = true,
  className = "",
  isSubheadline = true,
  isExcerpt = false,
  isSection = false,
  darkTheme = false,
  largeIcon = false,
  publisherAttributes,
  updatedFont = false,
  src = "",
  captionStyle = "",
  updateSubHeadline = false,
  isSmallCard = false,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  const { subheadline } = story;

  const imageCaption = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-caption"])
    ) {
      return get(story, ["hero-image-caption"]);
    } else return null;
  };

  const imageAttribute = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-attribution"])
    ) {
      return get(story, ["hero-image-attribution"]);
    } else return null;
  };

  const storyHeadline = getHeadline(story);

  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";

  const customStoryHeadlineStyle = updatedFont && src ? `${publisherAttributes.lang}-story-headline-${src}` : "";

  const headlineStyle = src ? customStoryHeadlineStyle : storyHeadlineStyle;
  const storyCardHeadlineStyle = isSmallCard
    ? `${publisherAttributes.lang}-small-story-headline-${src}`
    : headlineStyle;

  const excerpt = getExcerpt(story);
  const section = get(story, ["sections", "0"], null);

  return (
    <div
      styleName={`base ${publisherAttributes.lang}-base`}
      className={`custom-story-card-2  ${className}`}
      data-testid="stories-14"
    >
      <div styleName="story-data" className="story-data">
        {isSubheadline && subheadline ? (
          <Link href={story.url}>
            <Headline
              text={subheadline}
              headerLevel={3}
              className={`section-name ${updateSubHeadline ? `${publisherAttributes.lang}-custom-subheadline` : ""}`}
              styleName="sub-headline"
            />
          </Link>
        ) : null}
        <Link
          href={story.url}
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        >
          <Headline
            text={storyHeadline}
            headerLevel={headlineLevel}
            headlineType={headlineType}
            className="story-headline"
            styleName={storyCardHeadlineStyle}
          />
        </Link>
        {isExcerpt && excerpt ? (
          <Link
            href={story.url}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={datatrackinglabel}
          >
            <Headline
              text={excerpt}
              headerLevel={excerptLevel}
              headlineType={subHeadlineType}
              className={`sub-headline ${updatedFont ? `${publisherAttributes.lang}-custom-excerpt` : ""}`}
              styleName="story-excerpt"
              dangerouslySet={true}
            />
          </Link>
        ) : null}
        {isTagShown && story.tags && story.tags[0] ? <Tags data={story.tags[0]} /> : null}
        {isMetaDataShown ? (
          <StoryMetaData story={story} updatedFont={updatedFont} publisherLang={publisherAttributes.lang} src={src} />
        ) : null}
      </div>
      <div className="image-view">
        {showHeroImage && (
          <Link
            href={story.url}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={`${datatrackinglabel} image-view`}
          >
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
              darkTheme={darkTheme}
              largeIcon={largeIcon}
            />
            {isSection && section && (
              <Link href={section["section-url"]}>
                <div className="display-section" styleName="section-style">
                  {section["display-name"]}
                </div>
              </Link>
            )}
            { story["story-template"] === "audio" && 
              <div styleName="audio-icon-section">
                <div styleName="audio-icon">
                  <Play /> <span styleName="icon-text">{staticTexts(publisherAttributes.lang).audio}</span>
                </div>
              </div>
            }            
          </Link>
        )}
        {isImageCaptionRequired && imageCaption() && (
          <div styleName={`image-attribute ${captionStyle ? "default-caption-style" : ""}`} className="image-attribute">
            {imageCaption()}
            {imageAttribute() && (
              <span styleName="atrribute" className="attribute">
                {imageAttribute()}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

CustomStoryCard2.propTypes = {
  story: object.isRequired,
  isMetaDataShown: bool,
  isTagShown: bool,
  headlineLevel: number,
  headlineType: number,
  subHeadlineType: number,
  isImageCaptionRequired: bool,
  widths: array,
  imageType: string,
  aspectRatio: array,
  showHeroImage: bool,
  isTag: bool,
  className: string,
  isSubheadline: bool,
  excerptLevel: number,
  isExcerpt: bool,
  isSection: bool,
  darkTheme: bool,
  largeIcon: bool,
  publisherAttributes: object,
  updatedFont: bool,
  src: string,
  captionStyle: string,
  updateSubHeadline: bool,
  isSmallCard: bool,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(CustomStoryCard2);
